import React from "react";

import { showModal } from "@mapmycustomers/ui";

import i18nService from "@app/config/I18nService";

const confirmExit = (): Promise<boolean> =>
  new Promise((resolve, reject) => {
    const intl = i18nService.getIntl();
    if (!intl) {
      reject();
      return;
    }

    showModal({
      cancelButtonProps: {
        danger: true,
        type: "default",
      },
      cancelText: intl.formatMessage({
        id: "confirmExit.leave",
        defaultMessage: "Discard changes",
        description: "Cancel option in the Close Confirmation modal",
      }),
      centered: true,
      closable: false,
      content: (
        <span>
          {intl.formatMessage({
            id: "confirmExit.description",
            defaultMessage: "You have unsaved changes. Exiting now will discard all unsaved work.",
            description: "Description in the Close Confirmation modal",
          })}
        </span>
      ),
      maskClosable: false,
      okButtonProps: {
        type: "primary",
      },
      okText: intl.formatMessage({
        id: "confirmExit.stay",
        defaultMessage: "Keep Editing",
        description: "Ok option in the Close Confirmation modal",
      }),
      // must be a function which doesn't return any value, otherwise this
      // confirmation modal may stay on screen:
      onCancel: () => {
        resolve(true);
      },
      onOk: () => {
        resolve(false);
      },
      title: intl.formatMessage({
        id: "confirmExit.title",
        defaultMessage: "Save changes?",
        description: "Title of the Close Confirmation modal",
      }),
      type: "confirm",
      width: 520,
    });
  });

export default confirmExit;
